const wizardFilterVue = () => {
    const BASE_URL = document.getElementById('base_url').value;
	const endpoint_luoghi = `${BASE_URL}/wp-json/api/v1/localita`;
    let endpoint_results = `${BASE_URL}/wp-json/api/v1/results`;

	if ( document.getElementById('wizard-vue') ) {
		var app = new Vue({
			el: '#wizard-vue',
			    data() {
				    return {
                        luoghi : [],
                        regioni : [],
                        inputLuogo : '',
                        inputResults : '',
                        searchStrutture: [],
                        searchTipologie: [],
                        searchSpecialita : [],
                        searchMedici : [],
                        searchServizi : [],
                        searchPrestazioni : [],
                        searchProfessionisti : [],
                        loadingResults : false,
                        noResults: true,
                        endpoint_results_fetch: null,
                        endpoint_all_strutture_luogo : null,
                        allResultsUrl : '',
                        geoLabel : '',
                        currentStep : 1,
                        geoLocalizzaLoading: false,
                        datiGeo : 'disabled'
                    }
			    },
                mounted(){
                    fetch( endpoint_luoghi )
                    .then(res => res.json())
                    .then(data => {
                        this.luoghi = data;
                        this.regioni = data.filter(el => el.filter_type == 'regione');
                    })

                    localStorage.setItem('datiGeo', 'disabled');

                    //se ho nello storage il link a tutte le strutture lo fillo
                    if(localStorage.getItem('allResultsUrlStore') != null){
                        this.allResultsUrl = {
                            'url' : localStorage.getItem('allResultsUrlStore'),
                            'label' : localStorage.getItem('allResultsLabelStore')
                        };
                    }
                    
                    this.datiGeo = localStorage.getItem('datiGeo');
                    //se ho salvato posizione, vado direttamente allo step 2 e rilancio funzione per risultati

             
                    if(localStorage.getItem('geoLat') && localStorage.getItem('geoLong') &&  localStorage.getItem('datiGeo') == 'enabled'){
                        this.currentStep = 2;
                        this.geoLocalizza();
                    } else if(localStorage.getItem('geoLuogo') != null){
                        localStorage.setItem('datiGeo', 'disabled');
                        this.datiGeo = 'disabled';
                        if(localStorage.getItem('luogoType')){
                            this.step2(localStorage.getItem('geoLuogo'), localStorage.getItem('geoLuogoLabel'));
                        } else {
                            this.step2(localStorage.getItem('geoLuogo'), localStorage.getItem('geoLuogoLabel'), localStorage.getItem('luogoType'));
                        }
                        
                    }

                   
                },
                methods: {
                    emptyLuoghi(){
                        this.searchStrutture = [];
                        this.searchTipologie = [];
                        this.searchSpecialita = [];
                        this.searchMedici = [];
                        this.searchServizi = [];
                        this.searchPrestazioni = [];
                        this.searchProfessionisti = [];
                        this.loadingResults = false;
                        this.noResults = true;
                    },
                    step1(){
                        this.currentStep = 1;
          
                        document.querySelector('.wizard-search__step-2').classList.remove('visible')
                        document.querySelector('.wizard-search__step-1').classList.add('visible')

                    },
                    step2(luogo, luogoLabel, luogoType){

                        localStorage.setItem('geoLuogo', luogo);
                        
                        this.currentStep = 2;
                        this.emptyLuoghi();

                        if(luogoLabel){
                            this.geoLabel = luogoLabel;
                            localStorage.setItem('geoLuogoLabel', luogoLabel);
                        } else {
                            this.geoLabel = luogo;
                            localStorage.setItem('geoLuogoLabel', luogo);
                        }

                        document.querySelector('.wizard-search__step-1').classList.remove('visible')
                        document.querySelector('.wizard-search__step-2').classList.add('visible')
                        // Fetch delle località tramite parametro luogo
                        
                        if(luogo != ''){
                            this.endpoint_results_fetch = endpoint_results + '?q='+luogo;


                            //se ho luogotype preparo url endpoint alternativo per link a tutti risultati
                            if(luogoType){
                                localStorage.setItem('luogoType', luogoType);
                                this.endpoint_all_strutture_luogo = endpoint_results + '?q='+luogo +'&type='+luogoType
                            }
                        } else {
                            this.endpoint_results_fetch = endpoint_results;
  

                            if(luogoType){

                                localStorage.setItem('luogoType', luogoType);
                                this.endpoint_all_strutture_luogo = endpoint_results + '?type=ovunque'
                            }
                        }
                        this.getResults();
                        
                    },
                   async getResults(){
                        const response = await fetch( this.endpoint_results_fetch );
                        const rj = await response.json();

                        this.searchStrutture = rj.filter(el => el.type == 'strutture');
                        this.searchTipologie = rj.filter(el => el.type == 'tipologie');
                        this.searchSpecialita = rj.filter(el => el.type == 'specialita');
                        this.searchMedici = rj.filter(el => el.type == 'medici');
                        this.searchServizi = rj.filter(el => el.type == 'servizi');
                        this.searchPrestazioni = rj.filter(el => el.type == 'prestazioni');
                        this.searchProfessionisti = rj.filter(el => el.type == 'professionisti');
                        this.loadingResults = true;
                        
                        if(rj.length >0){
                            this.noResults = false
                        } else {
                            this.noResults = true
                        }

                        if(this.endpoint_all_strutture_luogo){
                            const allLuogoUrlEndpoint = await fetch( this.endpoint_all_strutture_luogo );
                            const allLuogoUrlResp = await allLuogoUrlEndpoint.json();
                            this.allResultsUrl = {
                                'url' : allLuogoUrlResp.url,
                                'label' : allLuogoUrlResp.label
                            };
                            localStorage.setItem('allResultsUrlStore', allLuogoUrlResp.url);
                            localStorage.setItem('allResultsLabelStore', allLuogoUrlResp.label);
                        }
                    
                    },
                    geoLocalizza(){
                        const good = document.querySelectorAll(".wizard-search__geocheck-good");

                        
                        this.geoLocalizzaLoading = true;
                        
                        /* Checking if the browser supports geolocation. If it does, it will get the
                        current position and hide the button. If it doesn't, it will display the
                        error message. */

                        if (navigator.geolocation) {
                            navigator.geolocation.getCurrentPosition(this.showPosition);
                            localStorage.setItem('datiGeo', 'enabled');
                            this.datiGeo = 'enabled';
                           
                            good.forEach(element => {
                                element.style.display = "flex";
                            });
                        } else { 
                            good.forEach(element => {
                                element.style.display = "flex";
                            });
                            this.geoLabel = "Geolocation is not supported by this browser.";
                        }
                    },
                    showPosition(position) {
                        let latitude = position.coords.latitude;
                        let longitude = position.coords.longitude;

                        localStorage.setItem('geoLat', position.coords.latitude);
                        localStorage.setItem('geoLong', position.coords.longitude);

                        if(localStorage.getItem('geoLat') && localStorage.getItem('geoLong')){
                            latitude = localStorage.getItem('geoLat');
                            longitude = localStorage.getItem('geoLong');
                        }

                        fetch('https://maps.googleapis.com/maps/api/geocode/json?latlng='+latitude+','+longitude+'&sensor=false&key=AIzaSyDP1TIkHbQcGYN99s2ytBnn5nVfpTU0zHQ')
                        .then(res => res.json())
                        .then(data => {
                            
                            this.getShortAddressObject(data.results)
                        })
                    },
                    getShortAddressObject(object) {
                        let address = {};
                        const address_components = object[0].address_components;
                        address_components.forEach(element => {
                            address[element.types[0]] = element.short_name;
                        });
                        
                        this.geoLabel = address.locality; //scrivo visivamente città

                        //devo fare una chiamate per vedere se ha risultati con la provincia se no continuo
                        fetch(endpoint_results +'?q='+address.administrative_area_level_2)
                        .then(res => res.json())
                        .then(data => {
                            if(data.length == 0){
                                 //devo fare una chiamate per vedere se ha risultati con la regione se no continuo
                                fetch(endpoint_results +'?q='+address.administrative_area_level_1)
                                .then(res => res.json())
                                .then(data => {
                                    if(data.length == 0){
                                        //faccio chiamata globale
                                        fetch(endpoint_results)
                                        .then(res => res.json())
                                        .then(data => {
                                            this.step2('', this.geoLabel);
                                        })
                                    } else {
                                        this.geoLocalizzaLoading = false;
                                        this.step2(address.administrative_area_level_1, this.geoLabel);
                                    }
                                })
                            } else {
                                this.geoLocalizzaLoading = false;
                                this.step2(address.administrative_area_level_2, this.geoLabel);
                            }
                        })
                        
                    },
                    stepBack(){
                        this.step1();
                        this.geoLabel = '';
                        this.datiGeo = 'disabled';
                        localStorage.setItem('datiGeo', 'disabled');
                        localStorage.removeItem('geoLuogo');
                        localStorage.removeItem('geoLuogoLabel');
                        

                        this.allResultsUrl = '';
                        localStorage.removeItem('luogoType');
                        localStorage.removeItem('allResultsUrlStore');
                        localStorage.removeItem('allResultsLabelStore');
                    }
                
                },
                
                computed: {
                    computedLuoghi(){			
					
                        return this.luoghi.filter( //controllo tutti gli item e mi ritorna solo gli elementi per cui il return è sempre true
    
                            (item) => {	
                            var label = this.inputLuogo ? (item.label.toLowerCase().includes(this.inputLuogo.toLowerCase())) : true
                                return label //restituisco l'item solo se la risposta è true / true / true
                            }
                        ) /* filter */
    
                    },
                    computedStrutture(){			
					
                        return this.searchStrutture.filter( //controllo tutti gli item e mi ritorna solo gli elementi per cui il return è sempre true
                            (item) => {	
                            var label = this.inputResults ? (item.name.toLowerCase().includes(this.inputResults.toLowerCase())) : true
                                return label //restituisco l'item solo se la risposta è true / true / true
                            }
                        ) /* filter */
    
                    },
                    computedTipologie(){			
					
                        return this.searchTipologie.filter( //controllo tutti gli item e mi ritorna solo gli elementi per cui il return è sempre true
                            (item) => {	
                            var label = this.inputResults ? (item.name.toLowerCase().includes(this.inputResults.toLowerCase())) : true
                                return label //restituisco l'item solo se la risposta è true / true / true
                            }
                        ) /* filter */
    
                    },
                    computedSpecialita(){			
					
                        return this.searchSpecialita.filter( //controllo tutti gli item e mi ritorna solo gli elementi per cui il return è sempre true
                            (item) => {	
                            var label = this.inputResults ? (item.name.toLowerCase().includes(this.inputResults.toLowerCase())) : true
                                return label //restituisco l'item solo se la risposta è true / true / true
                            }
                        ) /* filter */
    
                    },
                    computedMedici(){			
					
                        return this.searchMedici.filter( //controllo tutti gli item e mi ritorna solo gli elementi per cui il return è sempre true
                            (item) => {	
                            var label = this.inputResults ? (item.name.toLowerCase().includes(this.inputResults.toLowerCase())) : true
                                return label //restituisco l'item solo se la risposta è true / true / true
                            }
                        ) /* filter */
    
                    },
                    computedServizi(){			
					
                        return this.searchServizi.filter( //controllo tutti gli item e mi ritorna solo gli elementi per cui il return è sempre true
                            (item) => {	
                            var label = this.inputResults ? (item.name.toLowerCase().includes(this.inputResults.toLowerCase())) : true
                                return label //restituisco l'item solo se la risposta è true / true / true
                            }
                        ) /* filter */
    
                    },
                    computedPrestazioni(){			
					
                        return this.searchPrestazioni.filter( //controllo tutti gli item e mi ritorna solo gli elementi per cui il return è sempre true
                            (item) => {	
                            var label = this.inputResults ? (item.name.toLowerCase().includes(this.inputResults.toLowerCase())) : true
                                return label //restituisco l'item solo se la risposta è true / true / true
                            }
                        ) /* filter */
    
                    },
                    computedProfessionisti(){			
					
                        return this.searchProfessionisti.filter( //controllo tutti gli item e mi ritorna solo gli elementi per cui il return è sempre true
                            (item) => {	
                            var label = this.inputResults ? (item.name.toLowerCase().includes(this.inputResults.toLowerCase())) : true
                                return label //restituisco l'item solo se la risposta è true / true / true
                            }
                        ) /* filter */
    
                    }
                }
            }
        );
    }

}



const wizardSearch = () => {
    if(document.querySelector(".search-box-strutture")){
        wizardFilterVue();
    }
}


export default wizardSearch;